module.exports = __webpack_public_path__ + "static/media/closeToolbar.ba062a0e.svg";